<template>
  <a-modal
    :title="title === '1' ? $t('add') : $t('edit')"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('close')"
    wrapClassName="ant-modal-cust-warp"
    style="top:5%;overflow-y: hidden">

    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Frontend Page">
          <a-select v-decorator="[ 'page', validatorRules.page]" :placeholder="$t('select') + ' Frontend Page'">
            <a-select-option v-for='item in pages' :key='item.value'>
              {{item.value +  '-'+item[fieldName]}}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="User Type">
          <a-select v-decorator="[ 'userType', validatorRules.userType]" :placeholder="$t('select') + ' User Type'">
            <a-select-option v-for='item in userTypes' :key='item.value'>
              {{item[fieldName]}}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="OpenClose">
          <a-radio-group
            v-decorator="['pageSwitch', { initialValue: '1' }]">
            <span v-for="item in this.pageSwitchTypes">
              <a-radio :value=item.value>{{item[fieldName]}}</a-radio>
            </span>
          </a-radio-group>
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash/pick'
export default {
  name: "QuestionAnswerPageSwitchEdit",
  props: {
    userTypes: {
      type: Array,
      default: () => [],
    },
    pageSwitchTypes: {
      type: Array,
      default: () => [],
    },
    pages: {
      type: Array,
      default: () => [],
    },
    fieldName:{
      type: String,
      default: 'textCn',
    }
  },
  data () {
    return {
      title:"Action",
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules:{
        page:{
          rules: [
            { required: true, message: 'Please select page!' },
          ]},
        userType:{
          rules: [
            { required: true, message: 'Please select user Type!'},
          ]},
        pageSwitch:{
          rules: [
            { required: true, message: "Please select status!"},
          ]},
      },
    }
  },
  created () {
  },
  methods: {
    add () {
      this.edit({});
    },
    edit (record) {
      this.form.resetFields();
      this.open();
      this.model = Object.assign({}, record)
      this.model = {
        ...this.model,
        status: this.model.pageSwitch != undefined ? '' + this.model.pageSwitch : '1',
      }

      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'page', 'userType', 'pageSwitch'))
      });

    },
    open () {
      this.visible = true;
    },
    close () {
      this.$emit('close');
      this.visible = false;
    },
    openLoading () {
      this.confirmLoading = true;
    },
    closeLoading () {
      this.confirmLoading = false;
    },
    handleOk () {
      console.log(88888)
      const that = this;
      // Trigger form validation
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let formData = {
            ...values,
          }
          this.$emit('ok', formData);

        }
      })
    },
    handleCancel () {
      this.close()
    },
  }
}
</script>

<style scoped>

</style>